import createVueApp from '@phoenix/createVueApp';
import NewsletterForm from '@maison/components/form/NewsletterForm.vue';

const app = createVueApp({}, true);
app.component('NewsletterForm', NewsletterForm);
app.mount('#phoenix-newsletter-form');
